__turbopack_context__.v({
  "image": "StPEnG_image",
  "poster": "StPEnG_poster",
});
